import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';
import { PersonDetailsWrite } from './personDetailsWrite';

/** PersonDetailsWrite with a few extra fields required for Firm Forms */
export class PersonApplicationWrite extends PersonDetailsWrite {
  teamName: string;
  teamPublicName: string;
  selectedPositionPersonIds: Record<string, string[]>;
  /** positionDefinitionId -> personId -> the seat (tracked) field values collected for that person */
  selectedPositionSeatFieldValues: Record<string, Record<string, AttributeWrite[]>>;

  constructor(properties: Partial<PersonApplicationWrite> = undefined) {
    super(properties);
    if (properties) {
      this.teamName = properties.teamName;
      this.teamPublicName = properties.teamPublicName;
      this.selectedPositionPersonIds = properties.selectedPositionPersonIds;
      this.selectedPositionSeatFieldValues = properties.selectedPositionSeatFieldValues;
    }
  }
}
